import App from 'app/app.js';
import 'app/directive/LtScrollableCtrl.js';

function LtScrollableDirective() {
  return {
    restrict: 'E',
    scope: {
      scrollableContent: '@'
    },
    template: '<div lt-translate = {{scrollableContent}} ng-init="scrollable.init()"> </div>',
    controller: 'LtScrollableCtrl',
    controllerAs: 'scrollable'
  };
}

App.directive('ltScrollable', [LtScrollableDirective]);
